import React, { useContext, useEffect, useState } from "react";
import { useAppStore } from "../../../../../context/store";
import { Dialog, Portal, Field, CloseButton, Button, VStack, HStack, Spacer, Box, Select, createListCollection, Input } from "@chakra-ui/react";
import { floatingStyles, getGeometryTypeEntity, removeFileExtension } from "../../../../../utilies/Utility";
import { LuLayers } from "react-icons/lu";
import { addEntityWithOnlyPositions } from "../../../../../utilies/RightClickUtility";
import { JulianDate } from "cesium";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
const LayersMoveToAnotherLayer = () => {
  // state
  const moveToAnotherLayerDialog = useAppStore((s) => s.moveToAnotherLayerDialog);
  const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();

  // setter
  const setMoveToAnotherLayerDialog = useAppStore((s) => s.setMoveToAnotherLayerDialog);

  const [layersOptions, setLayersOptions] = useState(
    createListCollection({
      items: [],
    })
  );
  const [selectedLayer, setSelectedLayer] = useState(null);

  useEffect(() => {
    if (moveToAnotherLayerDialog && moveToAnotherLayerDialog.open) {
      let temp = [];

      const currentType = getGeometryTypeEntity(moveToAnotherLayerDialog.data[0]);

      for (const key in mapObjects) {
        const obj = mapObjects[key];
        if (!obj) continue;

        if (obj.geojson_type == currentType || obj.geojson_type == undefined || obj.geojson_type == null) {
          temp.push({
            label: removeFileExtension(obj.file_name),
            value: obj.id,
          });
        }
      }

      setLayersOptions(
        createListCollection({
          items: temp,
          itemToString: (item) => item.label,
          itemToValue: (item) => item.value,
        })
      );
    }
  }, [moveToAnotherLayerDialog]);

  const copyToAnotherLayer = () => {
    let selectedDataSource = null;
    for (const key in mapObjects) {
      if (mapObjects[key].id === selectedLayer) {
        selectedDataSource = mapObjects[key].dataSource;
        break;
      }
    }
    console.log(selectedDataSource);
    if (selectedDataSource && moveToAnotherLayerDialog && moveToAnotherLayerDialog.data.length != 0) {
      addEntityWithOnlyPositions(moveToAnotherLayerDialog.data, selectedDataSource, propreties);

      setMapObjects((prev) => {
        const next = [...prev] ;

        for (const key in next) {
          const item = next[key];
          if (item?.id === selectedLayer) {
            next[key] = { ...item, is_edited: true };
            break;
          }
        }

        return next;
      });

      setMoveToAnotherLayerDialog({
        open: false,
        data: null,
      });
    }
  };

  const [propreties, setPropreties] = useState([]);
  useEffect(() => {
    if (!selectedLayer) return;

    for (const key in mapObjects) {
      const obj = mapObjects[key];
      if (!obj || obj.id != selectedLayer) continue;

      const ds = obj.dataSource;
      let firstEntity = null;

      // try common datasource shapes
      if (ds) {
        if (Array.isArray(ds.entities)) {
          firstEntity = ds.entities[0];
        } else if (ds.entities && Array.isArray(ds.entities.values)) {
          firstEntity = ds.entities.values[0];
        } else if (ds.entities && typeof ds.entities.values === "function") {
          try {
            const vals = ds.entities.values();
            if (Array.isArray(vals)) firstEntity = vals[0];
          } catch (e) {}
        } else if (Array.isArray(ds._entities)) {
          firstEntity = ds._entities[0];
        } else if (Array.isArray(ds)) {
          firstEntity = ds[0];
        }
      }

      if (!firstEntity) {
        // set empty state when nothing found
        setPropreties([]);
        return;
      }

      const now = JulianDate.now();
      let maxId = 0;

      if (ds && ds.entities && Array.isArray(ds.entities.values)) {
        for (const ent of ds.entities.values) {
          let valObj = {};
          try {
            if (ent.properties && typeof ent.properties.getValue === "function") {
              valObj = ent.properties.getValue(now) || {};
            } else if (ent.properties) {
              valObj = ent.properties;
            }
          } catch (e) {}

          const n = Number(valObj.id);
          if (Number.isFinite(n) && n > maxId) maxId = n;
        }
      }

      const nextId = maxId + 2;

      // extract properties as plain object
      const propsObj = (() => {
        const p = firstEntity.properties;
        if (!p) {
          const fallback = {};
          for (const k in firstEntity) {
            if (Object.prototype.hasOwnProperty.call(firstEntity, k)) {
              const val = firstEntity[k];
              if (typeof val !== "function") fallback[k] = val;
            }
          }
          return fallback;
        }

        try {
          if (typeof p.getValue === "function") {
            const val = p.getValue();
            if (val && typeof val === "object") return { ...val };
          }
        } catch (e) {}

        const out = {};
        for (const k in p) {
          if (Object.prototype.hasOwnProperty.call(p, k)) {
            const val = p[k];
            if (typeof val !== "function") out[k] = val;
          }
        }
        return out;
      })();

      const entries = Object.entries(propsObj);

      // map entries into array of { key, value } and save to state
      if (entries.length === 0) {
        setPropreties([]);
      } else {
        setPropreties(
          entries.map(([k, v]) => ({
            key: k,
            // override id with nextId, otherwise keep original value
            value: k === "id" ? String(nextId) : v === undefined || v === null ? "" : String(v),
          }))
        );
      }

      break; // stop after handling selected layer
    }
  }, [selectedLayer]);

  // update a single property value
  const handlePropChange = (index, newValue) => {
    setPropreties((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], value: newValue };
      return copy;
    });
  };

  return (
    <Dialog.Root
      lazyMount
      closeOnInteractOutside={false}
      open={!!(moveToAnotherLayerDialog && moveToAnotherLayerDialog.open)}
      onOpenChange={(e) => {
        setMoveToAnotherLayerDialog({
          ...moveToAnotherLayerDialog,
          open: e.open,
        });
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <VStack gap={0}>
                <Dialog.Title textAlign={"left"} width={"full"}>
                  Copy To Another Layer
                </Dialog.Title>
              </VStack>
            </Dialog.Header>

            <Dialog.Body>
              <Field.Root mt={2}>
                <Box pos="relative" w="full">
                  <Select.Root
                    collection={layersOptions}
                    size="sm"
                    width="full"
                    onValueChange={(v) => {
                      setSelectedLayer(v.value[0]);
                    }}
                  >
                    <Select.HiddenSelect />

                    <Select.Control>
                      <Select.Trigger>
                        <Select.ValueText placeholder={"Layers"} />
                      </Select.Trigger>
                      <Select.IndicatorGroup>
                        <Select.ClearTrigger />
                        <Select.Indicator />
                      </Select.IndicatorGroup>
                    </Select.Control>

                    <Select.Positioner>
                      <Select.Content>
                        {layersOptions.items.map((item) => (
                          <Select.Item item={item} key={item.value}>
                            {item.label}
                            <Select.ItemIndicator />
                          </Select.Item>
                        ))}
                      </Select.Content>
                    </Select.Positioner>
                  </Select.Root>
                  <Field.Label css={floatingStyles}>
                    <LuLayers /> Layers
                  </Field.Label>
                </Box>
                {propreties.map((item, index) => (
                  <Field.Root key={item.key}>
                    <Field.Label>{item.key}</Field.Label>
                    <Input placeholder="Enter value ..." value={item.value} onChange={(e) => handlePropChange(index, e.target.value)} />
                  </Field.Root>
                ))}
              </Field.Root>
            </Dialog.Body>

            <Dialog.Footer>
              <HStack w="full" align="center">
                <Spacer />
                <Dialog.ActionTrigger asChild>
                  <Button variant="outline">Cancel</Button>
                </Dialog.ActionTrigger>
                <Button onClick={copyToAnotherLayer}>Copy</Button>
              </HStack>
            </Dialog.Footer>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersMoveToAnotherLayer;
